"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STRING_RESPONSE_CONNECTED = exports.MESSAGE_TYPE_UPSERT = exports.MESSAGE_TYPE_DELETE = exports.MESSAGE_TYPE_CONTENT_EVENT = exports.CHAT_STATE_ACTIVE = exports.CHAT_STATE_COMPOSING = exports.ROLE_MANAGER = exports.ROLE_CONTROLLER = exports.ROLE_ASSIGNED_AGENT = exports.EX_CONVERSATION_CHANGE_NOTIFICATION = exports.MESSAGING_EVENT_NOTIFICATION = exports.STRING_RESPONSE = exports.REQUEST_CONVERSATIONAL_RESPONSE = exports.messageObject = exports.updateConversationField = exports.chatState = exports.publishEvent = exports.consumerAuthentication = exports.subscribeMessagingEvents = exports.consumerRequestConversation = exports.subscribeExConversations = exports.getBrandProfile = exports.getUserProfile = exports.getClock = void 0;

var uuid = require('uuid/v4');

var getClock = function getClock() {
  return {
    body: {},
    headers: [{}],
    type: 'GetClock'
  };
};

exports.getClock = getClock;

var getUserProfile = function getUserProfile() {
  return {
    body: {},
    headers: [{}],
    type: 'userprofile.GetUserProfile'
  };
};

exports.getUserProfile = getUserProfile;

var getBrandProfile = function getBrandProfile(accountId) {
  return {
    body: {
      brandId: accountId
    },
    headers: [{}],
    type: 'brandprofile.GetBrandProfile'
  };
};

exports.getBrandProfile = getBrandProfile;

var subscribeExConversations = function subscribeExConversations() {
  return {
    body: {
      convState: ['OPEN']
    },
    headers: [{}],
    type: 'cqm.SubscribeExConversations'
  };
};

exports.subscribeExConversations = subscribeExConversations;

var consumerRequestConversation = function consumerRequestConversation(_ref) {
  var accountId = _ref.accountId,
      visitorId = _ref.visitorId,
      sessionId = _ref.sessionId,
      skillId = _ref.skillId;
  return {
    body: {
      brandId: accountId,
      channelType: 'MESSAGING',
      conversationContext: {
        visitorId: visitorId,
        sessionId: sessionId,
        interactionContextId: '3',
        type: 'SharkContext',
        lang: 'en-US'
      },
      skillId: skillId,
      ttrDefName: null
    },
    headers: [{}],
    type: 'cm.ConsumerRequestConversation'
  };
};

exports.consumerRequestConversation = consumerRequestConversation;

var subscribeMessagingEvents = function subscribeMessagingEvents(_ref2) {
  var conversationId = _ref2.conversationId,
      sequenceNumber = _ref2.sequenceNumber;
  return {
    body: {
      dialogId: conversationId,
      fromSeq: sequenceNumber
    },
    headers: [{}],
    type: 'ms.SubscribeMessagingEvents'
  };
};

exports.subscribeMessagingEvents = subscribeMessagingEvents;

var consumerAuthentication = function consumerAuthentication(jwtInternalToken) {
  return {
    body: {},
    headers: [{
      type: '.ams.headers.ClientProperties',
      features: ['AUTO_MESSAGES', 'RICH_CONTENT', 'CO_BROWSE', 'PHOTO_SHARING', 'QUICK_REPLIES', 'MULTI_DIALOG', 'FILE_SHARING'],
      appId: 'webAsync',
      integrationVersion: '3.0.26',
      integration: 'WEB_SDK'
    }, {
      jwt: jwtInternalToken,
      type: '.ams.headers.ConsumerAuthentication'
    }],
    type: 'InitConnection'
  };
};

exports.consumerAuthentication = consumerAuthentication;

var publishEvent = function publishEvent(conversationId, message) {
  return {
    body: {
      dialogId: conversationId,
      event: {
        type: 'ContentEvent',
        contentType: 'text/plain',
        message: message
      }
    },
    headers: [{}],
    type: 'ms.PublishEvent'
  };
};

exports.publishEvent = publishEvent;

var chatState = function chatState(conversationId, state) {
  return {
    body: {
      conversationId: conversationId,
      dialogId: conversationId,
      event: {
        type: 'ChatStateEvent',
        chatState: state
      }
    },
    headers: [{}],
    type: 'ms.PublishEvent'
  };
};

exports.chatState = chatState;

var updateConversationField = function updateConversationField(conversationId) {
  return {
    body: {
      conversationId: conversationId,
      conversationField: [{
        conversationState: 'CLOSE',
        field: 'ConversationStateField'
      }]
    },
    headers: [{}],
    type: 'cm.UpdateConversationField'
  };
};

exports.updateConversationField = updateConversationField;

var messageObject = function messageObject(_ref3) {
  var type = _ref3.type,
      body = _ref3.body,
      headers = _ref3.headers;
  return {
    kind: 'req',
    type: type,
    body: body || {},
    id: uuid(),
    headers: headers
  };
};

exports.messageObject = messageObject;
var REQUEST_CONVERSATIONAL_RESPONSE = 'cm.RequestConversationResponse';
exports.REQUEST_CONVERSATIONAL_RESPONSE = REQUEST_CONVERSATIONAL_RESPONSE;
var STRING_RESPONSE = 'StringResponse';
exports.STRING_RESPONSE = STRING_RESPONSE;
var MESSAGING_EVENT_NOTIFICATION = 'ms.MessagingEventNotification';
exports.MESSAGING_EVENT_NOTIFICATION = MESSAGING_EVENT_NOTIFICATION;
var EX_CONVERSATION_CHANGE_NOTIFICATION = 'cqm.ExConversationChangeNotification';
exports.EX_CONVERSATION_CHANGE_NOTIFICATION = EX_CONVERSATION_CHANGE_NOTIFICATION;
var ROLE_ASSIGNED_AGENT = 'ASSIGNED_AGENT';
exports.ROLE_ASSIGNED_AGENT = ROLE_ASSIGNED_AGENT;
var ROLE_CONTROLLER = 'CONTROLLER';
exports.ROLE_CONTROLLER = ROLE_CONTROLLER;
var ROLE_MANAGER = 'MANAGER';
exports.ROLE_MANAGER = ROLE_MANAGER;
var CHAT_STATE_COMPOSING = 'COMPOSING';
exports.CHAT_STATE_COMPOSING = CHAT_STATE_COMPOSING;
var CHAT_STATE_ACTIVE = 'ACTIVE';
exports.CHAT_STATE_ACTIVE = CHAT_STATE_ACTIVE;
var MESSAGE_TYPE_CONTENT_EVENT = 'ContentEvent';
exports.MESSAGE_TYPE_CONTENT_EVENT = MESSAGE_TYPE_CONTENT_EVENT;
var MESSAGE_TYPE_DELETE = 'DELETE';
exports.MESSAGE_TYPE_DELETE = MESSAGE_TYPE_DELETE;
var MESSAGE_TYPE_UPSERT = 'UPSERT';
exports.MESSAGE_TYPE_UPSERT = MESSAGE_TYPE_UPSERT;
var STRING_RESPONSE_CONNECTED = 'Connection initialized successfully';
exports.STRING_RESPONSE_CONNECTED = STRING_RESPONSE_CONNECTED;